export const MAX_CHAR_LIMIT = 3500;

export const addUserRole = {
  inspector: "Inspector",
  inspectorRole: {
    admin: "Admin",
    employee: "Employee",
    subInspector: "Sub-Inspector",
  },
  client: "Client",
  clientRole: {
    admin: "Admin",
    assetManager: "Asset Manager",
  },
  qc: "QC",
  internalUser: "Internal User",
};

export const userType = {
  tenant: 0,
  client: 1,
  inspector: 2,
};

export const permissionAccessLevels = {
  noAccess: 0,
  viewOnly: 1 << 0,
  fullAccess: 0x7fffffff,
};

export const monthOptions = [
  { value: "1", label: "January" },
  { value: "2", label: "February" },
  { value: "3", label: "March" },
  { value: "4", label: "April" },
  { value: "5", label: "May" },
  { value: "6", label: "June" },
  { value: "7", label: "July" },
  { value: "8", label: "August" },
  { value: "9", label: "September" },
  { value: "10", label: "October" },
  { value: "11", label: "November" },
  { value: "12", label: "December" },
];

export const yearOptions = Array.from(
  { length: new Date().getFullYear() - 1900 + 1 },
  (_, i) => {
    const year = 1900 + i;
    return { value: year.toString(), label: year.toString() };
  }
);

export const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const passwordRegex = /^[a-zA-Z0-9!@#$%^&*]{8,16}$/;
export const lowercaseRegex = /(?=.*[a-z])/;
export const uppercaseRegex = /(?=.*[A-Z])/;
export const specialCharRegex = /^(?=.*[!@#$%^&*])[A-Za-z0-9!@#$%^&*]+$/;
export const websiteRegex =
  /^(https?:\/\/)?(?!www\.[^\.]*$)(www\.)?[a-zA-Z0-9-]+\.[a-zA-Z]{2,}(\.[a-zA-Z]{2,})?([\/?#][^\s]*)?$/; // eslint-disable-line

export const deliveryMethodOptions = [
  { value: "Email", label: "Email" },
  {
    value: "NoAutomatedDelivery",
    label: "No Automated Delivery",
    hint: "(Sign in required to View and Download)",
  },
];
export const invoiceFormatOptions = ["Pdf"];
export const invoiceFrequencyOptions = [
  { value: "Individual", label: "Individual Invoices" },
  {
    value: "MonthlyBatch",
    label: "Monthly Batch Invoice - Last day of the month",
  },
  {
    value: "SemimonthlyBatch",
    label: "Semi-Monthly Batch - 15th & Last Day of the month",
  },
];

export const restrictionOptions = [
  "Background Check Completed",
  "Insurance Required",
];

export const formTemplateRestrictionOptions = [
  "Background Check Completed",
  "Certifications",
  "Insurance Required",
];

export const formElementTypes = {
  textField: "TextField",
  openEnd: "OpenEnd",
  singleSelect: "SingleSelect",
  multiSelect: "MultiSelect",
  matrix: "Matrix",
  singleDate: "SingleDate",
  photoRequest: "PhotoRequest",
  table: "Table",
  multiInput: "MultiInput",
};

export const photoResolutions = {
  standardResolution: "Standard",
  originalResolution: "Original",
};

export const orderFlagColor = {
  vipClient: "#81C784",
  statusNotChanged: "#FFEB3B",
  rush: "#9575CD",
  dueDate: "#FF8A65",
  openIssue: "#64B5F6",
  pastDue: "#E57373",
};

export const queueType = {
  created: "Created",
  validation: "Validation",
  assign: "Assign",
  accepted: "Accepted",
  qc: "Qc",
  inProgress: "InProgress",
  submitted: "Submitted",
  billing: "Billing",
  onHold: "OnHold",
  closed: "Closed",
};

export const getOrderStatusColor = (orderStatus: string) => {
  let color;
  if (
    orderStatus === "OrderAdded" ||
    orderStatus === "OrderReview" ||
    orderStatus === "OrderPending"
  ) {
    color = "#2196F3";
  } else if (
    orderStatus === "AutoValidation" ||
    orderStatus === "ManualValidation"
  ) {
    color = "#00ACC1";
  } else if (
    orderStatus === "AutoAssign" ||
    orderStatus === "ManualAssign" ||
    orderStatus === "Recruiting" ||
    orderStatus === "InspectorAssigned"
  ) {
    color = "#009688";
  } else if (
    orderStatus === "NoAppointment" ||
    orderStatus === "FutureAppointment" ||
    orderStatus === "PastAppointment" ||
    orderStatus === "InspectorReturn"
  ) {
    color = "#4CAF50";
  } else if (orderStatus === "InProgress") {
    color = "#4CAF50";
  } else if (orderStatus === "Submitted") {
    color = "#9C27B0";
  } else if (
    orderStatus === "UnassignedQC" ||
    orderStatus === "AssignedQC" ||
    orderStatus === "FinalQC" ||
    orderStatus === "ResultsDelivered"
  ) {
    color = "#9C27B0";
  } else if (
    orderStatus === "ToBeInvoiced" ||
    orderStatus === "Invoiced" ||
    orderStatus === "ClientReturns"
  ) {
    color = "#5E35B1";
  } else if (orderStatus === "OnHold") {
    color = "#EF6C00";
  } else if (orderStatus === "Closed" || orderStatus === "Cancelled") {
    color = "#2E7D32";
  }
  return color;
};

export const orderStatus = {
  // Created
  OrderAdded: 11,
  OrderReview: 12,
  OrderPending: 13,

  // Validation
  AutoValidation: 21,
  ManualValidation: 22,

  // Assign
  AutoAssign: 31,
  ManualAssign: 32,
  Recruiting: 33,
  InspectorAssigned: 34,

  // Accepted
  NoAppointment: 41,
  FutureAppointment: 42,
  PastAppointment: 43,
  InspectorReturn: 44,

  // QC
  UnassignedQC: 51,
  AssignedQC: 52,
  FinalQC: 53,
  ResultsDelivered: 54,
  Submitted: 55,

  // Billing
  ToBeInvoiced: 61,
  Invoiced: 62,
  ClientReturns: 63,

  // Closed
  Closed: 71,
  Cancelled: 72,

  // Hold
  OnHold: 81,
};

export const multiInputType = [
  { value: "OpenEnd", label: "Text Field" },
  { value: "SingleSelect", label: "Single Select" },
  { value: "MultiSelect", label: "Multi Select" },
];

export const multiInputFormat = [
  { value: "OpenText", label: "Open Text" },
  { value: "TextOnly", label: "Text Only" },
  { value: "NumbersOnly", label: "Numbers Only" },
  { value: "Currency", label: "Currency" },
  { value: "Percentage", label: "Percent" },
];

export const propertyDetailsTypes = [
  { value: "accountNumber", label: "Account Number" },
  { value: "referenceNumber", label: "Reference Number" },
  // { value: "propertyName", label: "Property Name" },
  { value: "collateralOrPropertyType", label: "Collateral Or Property Type" },
  {
    value: "collateralOrPropertyDescription",
    label: "Collateral Or Property Description",
  },
  { value: "yearBuilt", label: "Year Built" },
  { value: "yearRenovated", label: "Year Renovated" },
  { value: "nameOfBusiness", label: "Name Of Business" },
  { value: "businessPhone", label: "Business Phone" },
  { value: "numberOfUnits", label: "Number Of Units" },
  { value: "numberOfBuildings", label: "Number Of Buildings" },
  { value: "investorNumber", label: "Investor Number" },
  { value: "squareFootage", label: "Square Footage" },
  
  { value: "loanBalance", label: "Loan Balance" },
  { value: "loanBalanceAsOf", label: "Loan Balance As Of" },
  { value: "obligor", label: "Obligor" },
  { value: "obligation", label: "Obligation" },
  { value: "borrower", label: "Borrower" },
  { value: "dealerGroup", label: "Dealer Group" },
  { value: "dropDeadDate", label: "Drop Dead Date" },
  { value: "investorLoanNumber", label: "Investor Loan Number" },
  { value: "investorName", label: "Investor Name" },
  { value: "netRentableSquareFootage", label: "Net Rentable Square Footage" },
  // Asset Manager (collapsed into propertyRecordAssetManager on save)
  { value: "assetManager", label: "Asset Manager" },
  { value: "assetManagerEmail", label: "Asset Manager Email" },
  { value: "assetManagerPhone", label: "Asset Manager Phone" },
  // Additional details (mapped into propertyRecordAdditionalDetails on save)
  { value: "operationsAndMaintenance1", label: "Operations And Maintenance 1" },
  { value: "operationsAndMaintenance2", label: "Operations And Maintenance 2" },
  { value: "operationsAndMaintenance3", label: "Operations And Maintenance 3" },
  { value: "repair1", label: "Repair 1" },
  { value: "repair2", label: "Repair 2" },
  { value: "repair3", label: "Repair 3" },
  { value: "repair4", label: "Repair 4" },
  { value: "repair5", label: "Repair 5" },
  { value: "repair6", label: "Repair 6" },
  { value: "repair7", label: "Repair 7" },
  { value: "repair8", label: "Repair 8" },
  { value: "repair9", label: "Repair 9" },
  { value: "repair10", label: "Repair 10" },
  { value: "repair11", label: "Repair 11" },
  { value: "repair12", label: "Repair 12" },
  { value: "repair13", label: "Repair 13" },
  { value: "repair14", label: "Repair 14" },
  { value: "repair15", label: "Repair 15" },
  { value: "repair16", label: "Repair 16" },
  { value: "repair17", label: "Repair 17" },
  { value: "repair18", label: "Repair 18" },
  { value: "repair19", label: "Repair 19" },
  { value: "repair20", label: "Repair 20" },
].sort((a, b) =>
  a.label.localeCompare(b.label, undefined, { numeric: true })
);

export const assetManagerDetailTypes = {
  assetManager: "name",
  assetManagerEmail: "email",
  assetManagerPhone: "phone",
} as const;

export const additionalDetailTypeMap: Record<
  string,
  { type: "OperationsAndMaintenance" | "Repair"; index: number }
> = (() => {
  const map: Record<
    string,
    { type: "OperationsAndMaintenance" | "Repair"; index: number }
  > = {};
  for (let i = 1; i <= 3; i++) {
    map[`operationsAndMaintenance${i}`] = {
      type: "OperationsAndMaintenance",
      index: i,
    };
  }
  for (let i = 1; i <= 20; i++) {
    map[`repair${i}`] = { type: "Repair", index: i };
  }
  return map;
})();

export let qcReviewIsEdit = false;
export const setQCReviewIsEdit = (value: boolean) => {
  qcReviewIsEdit = value;
};
export const getQCReviewIsEdit = () => {
  return qcReviewIsEdit;
};

export const dateFilter = [
  { value: "On", label: "On" },
  { value: "Before", label: "Before" },
  { value: "OnOrBefore", label: "On or Before" },
  { value: "Between", label: "Between" },
  { value: "After", label: "After" },
  { value: "OnOrAfter", label: "On or After" },
];
